import { render, staticRenderFns } from "./PayslipView.vue?vue&type=template&id=9edb4174&scoped=true"
import script from "./PayslipView.vue?vue&type=script&lang=js"
export * from "./PayslipView.vue?vue&type=script&lang=js"
import style0 from "./PayslipView.vue?vue&type=style&index=0&id=9edb4174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9edb4174",
  null
  
)

export default component.exports